<template>
  <div id="app">
    <v-header></v-header>
    <router-view />
    <v-footer></v-footer>
  </div>
</template>

<script>
import vHeader from '@/components/header.vue'
import vFooter from '@/components/footer.vue'
export default {
  name: 'App',
  components: { vHeader, vFooter },
  mounted () {},
  methods: {
  }
}
</script>
<style type="text/scss" lang="scss">
#app{
  background: #f8f8f8;
}
.w1200{
  width: 1200px;margin: auto;
}
.sTitle{
  font-size: 18px;border-bottom: 2px solid #ddd;line-height: 2;padding-left: 10px;color: #666;
  span{float: right;}
}
.none{text-align: center;font-size: 16px;color: #999;padding-bottom: 100px;
  .icon{width: 100px;height: 100px;display: inline-block;margin: 60px auto 0 auto;background: #ddd;opacity: 0.3;
    &.ncart{background: url('/static/n1.png') center no-repeat;background-size: 60%;}
    &.nshop{background: url('/static/n4.png') center no-repeat;background-size: 60%;}
  }
  .t1{
    line-height: 1;margin: 0;color: #ccc;
  }
  .t2{
    span{margin-top: 100px;display: inline-block;background: #c2090f;color: #fff;padding: 8px 24px;border-radius: 4px;cursor: pointer;;}
  }
}
//添加地址
.addSpan{text-align: center;padding: 20px;
  span{
    display: inline-block;background: #c2090f;height: 36px;line-height: 36px;border-radius: 4px;cursor: pointer;color: #fff;font-size: 16px;padding-right: 16px;margin: auto;
    i{width: 36px;height: 36px;display: inline-block;background: url('/static/jia2.png') center no-repeat;background-size: 50%;vertical-align: middle;}
  }
}

</style>
